'use client';

import { menus } from '@benzinga/navigation-ui';
import Hooks from '@benzinga/hooks';
import { useIsUserLoggedIn } from '@benzinga/user-context';
import { Icon } from '@benzinga/core-ui';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import React from 'react';
import { DFPManager } from 'react-dfp';
import './tools.scss';
import { MoneyWidget } from '@benzinga/money';

export const RegisterDFPManager = () => {
  React.useEffect(() => {
    DFPManager.setTargetingArguments({
      BZ_PTYPE: 'tool',
    });
    return () => {
      DFPManager.setTargetingArguments({});
    };
  }, []);
  return <></>;
};

export const ToolsPageMain = ({ brokerWidget }) => {
  const isLoggedIn = Hooks.useHydrate(useIsUserLoggedIn(), false);
  const toolsMenu = menus.secondary.filter(menu => menu.label === 'Tools')[0].groups;
  return (
    <div className="tool-page-content tools-page-main">
      <div>
        <div className="header-section">
          <p className="subtitle">Supercharge Your Trading With Benzinga Tools</p>
        </div>
        <div className="tools-list-container">
          {toolsMenu?.map(menuItem => (
            <div className="tool-category-list-item" key={menuItem.label}>
              <h6 className="label">{menuItem.label}</h6>
              <ul className="tools-list">
                {menuItem.links.map(link => (
                  <li key={link.title}>
                    <a href={isLoggedIn && link.logged_in_href ? link.logged_in_href : link.href}>
                      <span>{link.title}</span>
                      <Icon icon={faArrowRight} />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="content-block-container">
        <MoneyWidget widget={brokerWidget} />
      </div>
    </div>
  );
};
